import { MutationTree } from 'vuex'

import InsuranceCompany from '@/store/defintions/types/InsuranceCompany'
import { CarePlan, DefinitionsState, Mutations, Service } from './types'

export default <MutationTree<DefinitionsState>>{
  [Mutations.SET_GENDER_DEFINITIONS](state, value: Map<string, string>) {
    state.genders = value
  },
  [Mutations.SET_SERVICES_DEFINITIONS](state, value: Service[]) {
    state.services = value
  },
  [Mutations.SET_REJECT_REASONS_DEFINITIONS](state, value: string[]) {
    state.rejectReasons = value
  },
  [Mutations.SET_CARE_PLANS_DEFINITIONS](state, value: CarePlan[]) {
    state.carePlans = value
  },
  [Mutations.SET_INSURANCE_COMPANIES_DEFINITIONS](
    state,
    value: InsuranceCompany[],
  ) {
    state.insuranceCompanies = value
  },
}
